<template>
    <div>
        <fatal-icons></fatal-icons>
        <div class="u-full-width u-d-block">
            <div class="u-d-flex u-flex-space-between">
                <h2>Claim Documents</h2>
                <div class="flex-grid flex-grid--reduced-bottom-margin u-padding-t-20">
                    <router-link v-if="claimType === 'fatal_accident_dependency'" :to="{ name: 'fatal::dependency.step-9', params : { id: claimId } }">
                        <svg viewBox="0 0 120 120" class="m-icon m-icon--dark">
                            <use xlink:href="#close"></use>
                        </svg>
                    </router-link>
                    <router-link v-if="claimType === 'fatal_accident_estate'" :to="{ name: 'fatal::estate.step-6', params : { id: claimId } }">
                        <svg viewBox="0 0 120 120" class="m-icon m-icon--dark">
                            <use xlink:href="#close"></use>
                        </svg>
                    </router-link>
                    <router-link v-if="claimType === 'lost_years'" :to="{ name: 'lost::step-8', params : { id: claimId } }">
                        <svg viewBox="0 0 120 120" class="m-icon m-icon--dark">
                            <use xlink:href="#close"></use>
                        </svg>
                    </router-link>
                    <router-link v-if="claimType === 'personal_injury'" :to="{ name: 'personal::step-9', params : { id: claimId } }">
                        <svg viewBox="0 0 120 120" class="m-icon m-icon--dark">
                            <use xlink:href="#close"></use>
                        </svg>
                    </router-link>
                </div>
            </div>

            <div class="u-d-flex a-form-inputs u-flex-wrap u-align-items-flex-end u-margin-bottom-20 u-r-margin-bottom-0">
                <div>
                    <div class="u-margin-bottom-10 u-bold">
                        Document Type
                    </div>
                    <select name="document_type" id="documentType" v-model="documentType">
                        <option value="" disabled hidden>Please select...</option>
                        <option value="offer_letter">Offer Letter</option>
                        <option value="executive_summary">Executive Summary</option>
                        <option value="schedule_of_loss">Schedule of Loss</option>
                        <option value="comparison_schedule">Comparison Schedule</option>
                    </select>
                </div>

                <div class="u-margin-trbl-0-0-0-10" v-if="documentType !== 'offer_letter' && documentType !== '' && claimType !== 'personal_injury'">
                    <div class="u-margin-bottom-10 u-bold">
                        Discount Rate
                    </div>
                    <control for="discount_rate" :table-control="true" :icon-space="false">
                    <select
                            class="u-full-width"
                            name="discount_rate"
                            id="discount_rate"
                            v-model.number="discountRate" v-field-control
                            @change="updateDiscountRate"
                            required>
                        <option :value="-2.00">-2.00%</option>
                        <option :value="-1.50">-1.50%</option>
                        <option :value="-1.00">-1.00%</option>
                        <option :value="-0.75">-0.75%</option>
                        <option :value="-0.50">-0.50%</option>
                        <option :value="-0.25">-0.25%</option>
                        <option :value="0.00">0.00%</option>
                        <option :value="0.50">0.50%</option>
                        <option :value="1.00">1.00%</option>
                        <option :value="1.50">1.50%</option>
                        <option :value="2.00">2.00%</option>
                        <option :value="2.50">2.50%</option>
                        <option :value="3.00">3.00%</option>
                    </select>
                    </control>
                </div>

                <button class="a-button u-margin-trbl-0-0-0-10"
                        @click="createDocument"
                        :class="documentType === '' ?'disabled':''"
                        :disabled="documentType === ''">Generate
                </button>

            </div>

            <div class="a-table--short-no-style">
                <table class="a-table u-full-width p-generate-schedule__table" cellpadding="0" cellspacing="0">
                    <tr>
                        <th><h2>Name</h2></th>
                        <th><h2>Type</h2></th>
                        <th><h2>Discount Rate</h2></th>
                        <th><h2>Created</h2></th>
                        <th><h2>Updated</h2></th>
                        <th></th>
                    </tr>
                    <tr v-for="(document, index) in getGeneratedDocuments">
                        <td>{{ document.name }}</td>
                        <td style="text-transform: capitalize;">{{ document.type.replace(/[_-]/g, " ") }}</td>
                        <td>{{ parseFloat(document.discount_rate).toFixed(2) }}%</td>
                        <td>{{ formatDate(document.created_at) }}</td>
                        <td>{{ formatDate(document.updated_at) }}</td>
                        <td width="200">
                            <div class="u-d-flex u-flex-space-between">
                                <router-link v-if="claimType === 'fatal_accident_dependency'" :to="{ name: 'fatal::dependency.documents.editor', params : { id: claimId, document_id: index } }" style="width: 22px;">
                                    <div class="u-float-l" v-if="document.type !== 'executive_summary'">
                                        <icon-tooltip :tooltip-name="'edit_' + index" tooltip-text="edit" side="left" text-width="110" icon-type="edit"></icon-tooltip>
                                    </div>
                                </router-link>

                                <router-link v-if="claimType === 'fatal_accident_estate'" :to="{ name: 'fatal::estate.documents.editor', params : { id: claimId, document_id: index } }" style="width: 22px;">
                                    <div class="u-float-l" v-if="document.type !== 'executive_summary'">
                                        <icon-tooltip :tooltip-name="'edit_' + index" tooltip-text="edit" side="left" text-width="110" icon-type="edit"></icon-tooltip>
                                    </div>
                                </router-link>

                                <router-link v-if="claimType === 'lost_years'" :to="{ name: 'lost::documents.editor', params : { id: claimId, document_id: index } }" style="width: 22px;">
                                    <div class="u-float-l" v-if="document.type !== 'executive_summary'">
                                        <icon-tooltip :tooltip-name="'edit_' + index" tooltip-text="edit" side="left" text-width="110" icon-type="edit"></icon-tooltip>
                                    </div>
                                </router-link>

                                <router-link v-if="claimType === 'personal_injury'" :to="{ name: 'personal::documents.editor', params : { id: claimId, document_id: index } }" style="width: 22px;">
                                    <div class="u-float-l">
                                        <icon-tooltip v-if="document.type !== 'executive_summary'" :tooltip-name="'edit_' + index" tooltip-text="edit" side="left" text-width="110" icon-type="edit"></icon-tooltip>
                                    </div>
                                </router-link>

                                <a :href="'/api/v1/generated-documents/pdf/'+document.id+'?access_token='+getToken" target="_blank" v-if="document.type !== 'comparison_schedule'">
                                    <div class="u-float-l">
                                        <icon-tooltip :tooltip-name="'download_schedule_of_loss' + index" tooltip-text="download" side="left" text-width="150" icon-type="download"></icon-tooltip>
                                    </div>
                                </a>

                                <a :href="'/api/v1/comparison-schedule/pdf/'+document.id+'?document_id='+document.id+'&discount_rate='+document.discount_rate+'&access_token='+getToken" target="_blank" v-if="document.type === 'comparison_schedule'">
                                    <div class="u-float-l">
                                        <icon-tooltip :tooltip-name="'download_comparison_schedule' + index" tooltip-text="download" side="left" text-width="150" icon-type="download"></icon-tooltip>
                                    </div>
                                </a>

                                <span @click="deleteDocument(document)">
                                    <div class="u-float-l">
                                        <icon-tooltip :tooltip-name="'delete' + index" tooltip-text="delete" side="left" text-width="110" icon-type="delete"></icon-tooltip>
                                    </div>
                                </span>
                            </div>

                        </td>
                    </tr>
                    <tr v-if="getGeneratedDocuments.length === 0">
                        <td colspan="6">
                            <p class="u-text-center">
                                No claim documents created yet.
                            </p>
                        </td>
                    </tr>
                </table>
            </div>

            <!--<ul class="m-pagination">
                <li v-for="page in pageNumbers" class="m-pagination__item"
                    :class="[ page == isActive ? 'm-pagination__item--active' : '']">
                    <a href="#" @click.prevent="changePage(page)">
                        {{ page }}
                    </a>
                </li>
            </ul> -->

        </div>

    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import fatalIcons from 'components/documents/Icons.vue';
    import DocumentEditor from 'components/documents/DocumentEditor.vue';
    import store from 'store/index';
    import moment from 'moment';
    import IconTooltip from 'components/IconTooltip.vue';
    import Control from 'components/form/Control.vue';

    export default {
        name: 'documents',
        data() {
            return {
                discountRate: null,
                documentType: '',
                filter: false,
                filterOptions: {
                    comparison_schedule: true,
                    schedule_of_loss: true,
                    offer_letter: true
                },
                pagination: {},
                offset: 4,
                documents: []
            }
        },
        created() {
            this.getGeneratedDocumentsFromServer({
                claimId: this.claimId,
                page: 1,
                filter: this.filterOptions
            });
        },
        mounted() {
            this.pagination = this.getPagination;
            this.discountRate = this.discountRateForDocument();
        },
        components: {
            fatalIcons,
            DocumentEditor,
            IconTooltip,
            Control
        },
        computed: {
            ...mapGetters('claim', {
                claimId: 'id',
                claimType: 'type'
            }),
            ...mapGetters('user', [
                'getToken',
            ]),
            ...mapGetters('documents', {
                getGeneratedDocuments: 'getGeneratedDocuments',
                getEditingDocument: 'getEditingDocument',
                requesting: 'getRequestStatus',
                findDocument: 'getGeneratedDocument',
                getPagination: 'getPagination',
            }),
            ...mapGetters('http', [
                'running',
                'apiRouteRequestRunning'
            ]),
            ...mapGetters('lost/claimant', {
                getLostYearsDiscountRate: 'getClaimantInfoValue'
            }),
            ...mapGetters('personal/claimant', {
                getPersonalInjuryDiscountRate: 'getClaimInfo'
            }),
            ...mapGetters('fatal/dependency/claimDetails', {
                getDependencyDiscountRate: 'discountRate'
            }),
            ...mapGetters('fatal/estate/claimDetails', {
                getEstateDiscountRate: 'discountRate'
            }),
            isActive: function () {
                return this.pagination.current_page;
            },
            pageNumbers: function () {
                if (!this.pagination.to) {
                    return [];
                }
                let from = this.pagination.current_page - this.offset;
                if (from < 1) {
                    from = 1;
                }
                let to = from + (this.offset * 2);
                if (to >= this.pagination.last_page) {
                    to = this.pagination.last_page;
                }
                let pagesArray = [];
                while (from <= to) {
                    pagesArray.push(from);
                    from++;
                }
                return pagesArray;
            }
        },
        methods: {
            ...mapActions('documents', {
                toggleContent: 'toggleEditingDocument',
                createGeneratedDocument: 'createGeneratedDocument',
                deleteGeneratedDocument: 'deleteGeneratedDocument',
                getGeneratedDocumentsFromServer: 'getGeneratedDocumentsFromServer',
            }),
            changePage: function (page) {
                this.pagination.current_page = page;
                this.getGeneratedDocumentsFromServer({
                        claimId: this.claimId,
                        page: this.pagination.current_page,
                        filter: this.filterOptions
                    });
            },
            filterDocuments() {
                this.pagination.current_page = 1;
                this.getGeneratedDocumentsFromServer({
                    claimId: this.claimId,
                    page: this.pagination.current_page,
                    filter: this.filterOptions
                });
            },
            toggleFilter() {
                this.filter = !this.filter;
            },
            createDocument: _.debounce(function (e) {
                this.createGeneratedDocument({
                    claimId: this.claimId,
                    claimType: store.getters['claim/type'],
                    type: this.documentType,
                    discountRate: this.discountRate
                });
            }, 500),
            deleteDocument(document) {
                if (this.requesting) {
                    return;
                }
                this.deleteGeneratedDocument(document);
            },
            discountRateForDocument() {
                switch(this.claimType) {
                    case 'fatal_accident_dependency' :
                        return this.getDependencyDiscountRate;
                    case 'fatal_accident_estate' :
                        return this.getEstateDiscountRate;
                    case 'lost_years' :
                         return this.getLostYearsDiscountRate('discountRate');
                    case 'personal_injury' :
                        return this.getPersonalInjuryDiscountRate('discountRate');
                }
            },
            updateDiscountRate(event) {
                this.discountRate = event.target.value;
            },
            formatDate(dateStr) {
                return moment(dateStr).format('DD/MM/YYYY HH:mm');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// DocumentList.vue?5cfe50f8